export default class DtoBoreholeDrillingItem {
    constructor(obj) {
        this.idStation = obj.idStation
        this.order = obj.order
        this.diameterSymbol = obj.diameterSymbol
        this.depth = obj.depth
        this.comment = obj.comment
        this.headers = ['diameterSymbol', 'depth', 'comment']
    }
}